// methods here build URLs for site pages

import gridUtils from './gridUtils.js'
import deepCopyService from './deepCopyService.js'
import utilityService from './utilityService.js'
import drawdownService from './drawdownService.js'
// import drawUpService from './drawUpService.js'

export default {
    mixins: [gridUtils, deepCopyService, utilityService, drawdownService],
    methods: {
        loadNativeOrderArraysFromDraftJSON(tieup, threading, treadling, warpThreads, weftThreads, sampleDraft) {
            this.loadNativeOrderTieupArrayFromDraftJSON(tieup, sampleDraft)
            this.loadNativeOrderThreadingArrayFromDraftJSON(threading, sampleDraft)
            this.loadNativeOrderTreadlingArrayFromDraftJSON(treadling, sampleDraft)
            this.loadNativeOrderWarpThreadsArrayFromDraftJSON(warpThreads, sampleDraft)
            this.loadNativeOrderWeftThreadsArrayFromDraftJSON(weftThreads, sampleDraft)
        },

        loadDraftJSONFromNativeOrderArrays(tieup, threading, treadling, warpThreads, weftThreads, sampleDraft) {
            this.loadDraftJSONFromNativeOrderTieupArray(tieup, sampleDraft)
            this.loadDraftJSONFromNativeOrderThreadingArray(threading, sampleDraft, false)
            this.loadDraftJSONFromNativeOrderTreadlingArray(treadling, sampleDraft)
            this.loadDraftJSONFromNativeOrderWarpThreadsArray(warpThreads, sampleDraft)
            this.loadDraftJSONFromNativeOrderWeftThreadsArray(weftThreads, sampleDraft)
            this.removeEmptyThreadsAtEnd(threading, warpThreads)
            this.removeEmptyThreadsAtEnd(treadling, weftThreads)
        },

        loadNativeOrderTieupArrayFromDraftJSON(tieup, sampleDraft) {
            for (let shaft=0; shaft < sampleDraft.ShaftsCount; shaft++) {
                tieup[shaft] = new Array(sampleDraft.TreadlesCount)
            }
            for (let treadle = 0; treadle < sampleDraft.TreadlesCount; treadle++) {
                let shaftsTiedToTreadle = sampleDraft.Tieup[treadle]
                let col = treadle
                for (let shaft of shaftsTiedToTreadle) {
                    let row = shaft
                    tieup[row][col] = true
                }
            }
        },

        loadNativeOrderThreadingArrayFromDraftJSON(threading, sampleDraft) {
            for (let shaft = 0; shaft < sampleDraft.ShaftsCount; shaft++) {
                threading[shaft] = new Array(sampleDraft.WarpThreadsCount)
            }

            for (let warpThread=0; warpThread < sampleDraft.WarpThreadsCount; warpThread++) {
                let shaftsForWarpThread = sampleDraft.Threading[warpThread]
                let col = warpThread
                for (let shaft of shaftsForWarpThread) {
                    let row = shaft
                    threading[row][col] = true
                }
            }
            // console.log('loadNativeOrderThreadingArrayFromDraftJSON threading: ' + JSON.stringify(threading))
            // console.log('loadNativeOrderThreadingArrayFromDraftJSON sampleDraft: ' + JSON.stringify(sampleDraft))
        },

        loadNativeOrderTreadlingArrayFromDraftJSON(treadling, sampleDraft) {
            for (let pick=0; pick < sampleDraft.WeftThreadsCount; pick++) {
                treadling[pick] = new Array(sampleDraft.TreadlesCount)
            }
            for (let pick = 0; pick < sampleDraft.WeftThreadsCount; pick++) {
                let treadleNumbers = sampleDraft.Treadling[pick]
                let row = pick
                for (let treadle of treadleNumbers) {
                    let col = treadle
                    treadling[row][col] = true
                }
            }
            // console.log('treadling: ' + JSON.stringify(treadling))
            // console.log('sampleDraft: ' + JSON.stringify(sampleDraft))
        },

        loadNativeOrderWarpThreadsArrayFromDraftJSON(warpThreads, sampleDraft) {
            for (let threadNumber=0; threadNumber < sampleDraft.WarpThreadsCount; threadNumber++) {
                let col = threadNumber
                warpThreads[col] = JSON.parse(JSON.stringify(sampleDraft.WarpThreads[threadNumber])) // makes a deep copy of the color structure
            }
        },

        loadNativeOrderWeftThreadsArrayFromDraftJSON(weftThreads, sampleDraft) {
            for (let threadNumber=0; threadNumber < sampleDraft.WeftThreadsCount; threadNumber++) {
                let row = threadNumber
                weftThreads[row] = JSON.parse(JSON.stringify(sampleDraft.WeftThreads[threadNumber])) // makes a deep copy of the color structure
            }
        },

        getThreadingSequenceFromDraftJSON(sampleDraft) {
            return this.get1dSequenceArray(sampleDraft.Threading)
        },

        getTreadlingSequenceFromDraftJSON(sampleDraft) {
            return this.get1dSequenceArray(sampleDraft.Treadling)
        },

        get1dSequenceArray(treadlingOrThreading) {
            let destArr = []
            for (let r=0; r < treadlingOrThreading.length; r++) {
                destArr.push(treadlingOrThreading[r][0])
            }
            return destArr
        },

        loadDraftJSONFromNativeOrderWarpThreadsArray(warpThreads, sampleDraft) {
            sampleDraft.WarpThreads = []
            for (let warpThreadNum=0; warpThreadNum < sampleDraft.WarpThreadsCount; warpThreadNum++) {
                let col = warpThreadNum
                let warpThread = warpThreads[col]
                sampleDraft.WarpThreads.push(warpThread)
            }
        },

        loadDraftJSONFromNativeOrderWeftThreadsArray(weftThreads, sampleDraft) {
            sampleDraft.WeftThreads = []
            for (let weftThreadNum=0; weftThreadNum < sampleDraft.WeftThreadsCount; weftThreadNum++) {
                let row = weftThreadNum
                let weftThread = weftThreads[row]
                sampleDraft.WeftThreads.push(weftThread)
            }
        },

        loadDraftJSONFromNativeOrderThreadingArray(threading, sampleDraft, skipUnassignedThreads) {
            sampleDraft.Threading = []
            for (let warpThread=0; warpThread < sampleDraft.WarpThreadsCount; warpThread++) {
                let shaftsForThread = []
                let col = warpThread
                for (let shaft=0; shaft < sampleDraft.ShaftsCount; shaft++) {
                    let row = shaft
                    if (threading[row][col]) {
                        shaftsForThread.push(shaft)
                    }
                }
                if (skipUnassignedThreads) {
                    if (shaftsForThread.length > 0) { // skip warp threads that don't have any shaft assigned
                        sampleDraft.Threading.push(shaftsForThread)
                    }
                }
                else {
                    sampleDraft.Threading.push(shaftsForThread)
                }
            }
        },

        loadDraftJSONFromNativeOrderTreadlingArray(treadling, sampleDraft) {
            sampleDraft.Treadling = []
            for (let pick=0; pick < sampleDraft.WeftThreadsCount; pick++) {
                let treadlesForPick = []
                sampleDraft.Treadling.push(treadlesForPick)
                let row = pick
                for (let treadle=0; treadle < sampleDraft.TreadlesCount; treadle++) {
                    let col = treadle
                    if (treadling[row][col]) {
                        treadlesForPick.push(treadle)
                    }
                }
            }
        },

        loadDraftJSONFromNativeOrderTieupArray(tieup, sampleDraft) {
            sampleDraft.Tieup = []
            for (let treadle=0; treadle < sampleDraft.TreadlesCount; treadle++) {
                let shaftsForTreadle = []
                sampleDraft.Tieup.push(shaftsForTreadle)
                let col = treadle
                for (let shaft=0; shaft < sampleDraft.ShaftsCount; shaft++) {
                    let row = shaft
                    if (tieup[row][col]) {
                        shaftsForTreadle.push(shaft)
                    }
                }
            }
        },

        loadDraftFromArrays(tieup, warpThreads, threading, weftThreads, treadling, isRisingShed) {
            let jsonDraft = {}
            jsonDraft.ShaftsCount = tieup.length // rows count
            jsonDraft.TreadlesCount = tieup[0].length // columns count
            jsonDraft.WarpThreadsCount = warpThreads.length
            jsonDraft.WeftThreadsCount = weftThreads.length
            jsonDraft.IsRisingShed = isRisingShed

            // warp threads
            this.loadDraftJSONFromNativeOrderWarpThreadsArray(warpThreads, jsonDraft)

            // weft threads
            this.loadDraftJSONFromNativeOrderWeftThreadsArray(weftThreads, jsonDraft)

            // threading
            this.loadDraftJSONFromNativeOrderThreadingArray(threading, jsonDraft, false)

            // treadling
            this.loadDraftJSONFromNativeOrderTreadlingArray(treadling, jsonDraft)

            // tieup
            this.loadDraftJSONFromNativeOrderTieupArray(tieup, jsonDraft)

            return jsonDraft
        },

        removeEmptyThreadsAtEnd(threadingArray, threadColorsArray, rowsRepresentShafts) {
            let keepThreadingEntries = []
            let keepThreadColorEntries = []

            // threading grid has threads in columns, treadling grid has threads in rows, colors array is only 1d and always has colors in ascending thread number order
            // it's easier to work with empty rows rather than columns, so rotate the threading array before removing empty rows, and then again afterwards,
            // no need to do this for the treadling as the threads already correspond to rows
            let arrayToClean = rowsRepresentShafts ? this.rotate2dArray(threadingArray) : threadingArray

            let lastNonEmptyIndex = arrayToClean.length-1
            while (lastNonEmptyIndex >= 0 && this.rowIsEmpty(lastNonEmptyIndex, arrayToClean)) {
                lastNonEmptyIndex--
            }

            for (let r=0; r <= lastNonEmptyIndex; r++) {
                keepThreadingEntries.push(arrayToClean[r])
                keepThreadColorEntries.push(threadColorsArray[r])
            }

            if (rowsRepresentShafts) {
                // console.log('keepThreadingEntries: ' + JSON.stringify(keepThreadingEntries))
                if (keepThreadingEntries.length > 0) {
                    keepThreadingEntries = this.rotate2dArray(keepThreadingEntries)
                }
            }

            threadingArray.length = 0
            threadColorsArray.length = 0

            for (let c = 0; c < keepThreadingEntries.length; c++) {
                threadingArray.push(keepThreadingEntries[c])
            }
            for (let c = 0; c < keepThreadColorEntries.length; c++) {
                threadColorsArray.push(keepThreadColorEntries[c])
            }
        },

        countEmptyThreads(threadingArray, rowsRepresentShafts) {
            let emptyThreadsCount = 0
            // threading grid has threads in columns, treadling grid has threads in rows, colors array is only 1d and always has colors in ascending thread number order
            // it's easier to work with empty rows rather than columns, so rotate the threading array before removing empty rows, and then again afterwards,
            // no need to do this for the treadling as the threads already correspond to rows
            let arrayToClean = rowsRepresentShafts ? this.rotate2dArray(threadingArray) : threadingArray

            for (let r=0; r < arrayToClean.length; r++) {
                if (this.rowIsEmpty(r, arrayToClean)) {
                    emptyThreadsCount++
                }
            }
            return emptyThreadsCount
        },

        nonEmptyWarpThreadsCount(draftJSON) {
            let threading = new Array(draftJSON.ShaftsCount)
            this.loadNativeOrderThreadingArrayFromDraftJSON(threading, draftJSON)
            return draftJSON.WarpThreadsCount - this.countEmptyThreads(threading, true)
        },

        nonEmptyWeftThreadsCount(draftJSON) {
            let treadling = new Array(draftJSON.WeftThreadsCount)
            this.loadNativeOrderTreadlingArrayFromDraftJSON(treadling, draftJSON)
            return draftJSON.WarpThreadsCount - this.countEmptyThreads(treadling, true)
        },

        addShaft(tieup, threading, position, optionalTieupEntry, optionalThreadingEntry) {
            this.insert2dRowMajorGridRow(tieup, position)
            this.insert2dRowMajorGridRow(threading, position)
            if (optionalTieupEntry && optionalTieupEntry.length > 0) {
                tieup[position] = optionalTieupEntry
            }
            if (optionalThreadingEntry && optionalThreadingEntry.length > 0) {
                threading[position] = optionalThreadingEntry
            }
        },

        addTreadle(tieup, treadling, position, optionalTieupEntry, optionalTreadlingEntry) {
            this.insert2dRowMajorGridColumn(tieup, position)
            this.insert2dRowMajorGridColumn(treadling, position)
            if (optionalTieupEntry && optionalTieupEntry.length > 0) {
                for (let row=0; row < tieup.length; row++) {
                    console.log('tieup row advance: ' + row + ', position: ' + position)
                    tieup[row][position] = optionalTieupEntry[row]
                }
            }
            if (optionalTreadlingEntry && optionalTreadlingEntry.length > 0) {
                for (let row=0; row < treadling.length; row++) {
                    console.log('treadling row advance: ' + row + ', position: ' + position)
                    treadling[row][position] = optionalTreadlingEntry[row]
                }
            }
        },

        getNewThreadColor(threadsArray, newThreadPosition) {
            let threadColorIndex = (newThreadPosition > 0) ? newThreadPosition - 1 : newThreadPosition + 1
            if (threadColorIndex < threadsArray.length) {
                return this.deepCopy(threadsArray[threadColorIndex])
            }
            return { R: 0, G: 0, B: 0 }
        },

        addWarpThreadColors(warpThreads, position, count) {
            let newThreadsColor = this.getNewThreadColor(warpThreads, position)
            console.log('before addWarpThreadColors, position: ' + position + ', count: ' + count + ' ' + JSON.stringify(warpThreads))
            for (let c=0; c < count; c++) {
                this.insert1dGridColumn(warpThreads, position)
                warpThreads[position] = newThreadsColor
            }
            console.log('newThreadsColor: ' + JSON.stringify(newThreadsColor))
            console.log('after addWarpThreadColors, position: ' + position + ', count: ' + count + ' ' + JSON.stringify(warpThreads))
        },

        addWeftThreadColors(weftThreads, position, count) {
            let newThreadsColor = this.getNewThreadColor(weftThreads, position)
            for (let c=0; c < count; c++) {
                this.insert1dGridColumn(weftThreads, position)
                weftThreads[position] = newThreadsColor
            }
        },

        addWarpThreads(threading, warpThreads, position, count) {
            if (position >= 0) { // shouldn't happen unless UI bug
                for (let c=0; c < count; c++) {
                    this.insert2dRowMajorGridColumn(threading, position)
                }
                this.addWarpThreadColors(warpThreads, position, count)
            }
        },

        addWeftThreads(treadling, weftThreads, position, count) {
            if (position >= 0) { // shouldn't happen unless UI bug
                for (let c=0; c < count; c++) {
                    this.insert2dRowMajorGridRow(treadling, position)
                }
                this.addWeftThreadColors(weftThreads, position, count)
            }
        },

        clearWarpThreads(threading, warpThreads, position, count) {
            console.log('clearWarpThreads, position: ' + position + ', count: ' + count)
            for (let c=0; c < count; c++) {
                if (warpThreads.length > 1) {
                    this.clearEntireColumn(position + c, threading)
                }
            }
        },

        clearWeftThreads(treadling, weftThreads, position, count) {
            console.log('clearWeftThreads, position: ' + position + ', count: ' + count)
            for (let c=0; c < count; c++) {
                if (weftThreads.length > 1) {
                    this.clearEntireRow(position + c, treadling)
                }
            }
        },

        removeShaft(tieup, threading, position) {
            this.remove2dRowMajorGridRow(tieup, position)
            this.remove2dRowMajorGridRow(threading, position)
        },

        removeTreadle(tieup, treadling, position) {
            this.remove2dRowMajorGridColumn(tieup, position)
            this.remove2dRowMajorGridColumn(treadling, position)
        },

        removeWarpThreads(threading, warpThreads, position, count) {
            for (let c=0; c < count; c++) {
                if (this.warpThreadsCount > 1) {
                    this.remove2dRowMajorGridColumn(this.threading, position)
                    this.remove1dGridColumn(this.warpThreads, position)
                }
            }
        },

        removeWeftThreads(treadling, weftThreads, position, count) {
            for (let c=0; c < count; c++) {
                if (this.weftThreadsCount > 1) {
                    this.remove2dRowMajorGridRow(treadling, position)
                    this.remove1dGridColumn(weftThreads, position)
                }
            }
        },

        moveShaft(tieup, threading, sourcePosition, destPosition) {
            if (sourcePosition === destPosition) {
                return
            }
            console.log('moveShaft, source: ' + sourcePosition + ', dest: ' + destPosition)
            let threadingSourceRow = threading[sourcePosition]
            let tieupSourceRow = tieup[sourcePosition]
            this.removeShaft(tieup, threading, sourcePosition)
            this.addShaft(tieup, threading, destPosition, tieupSourceRow, threadingSourceRow)
        },

        moveTreadle(tieup, treadling, sourcePosition, destPosition) {
            if (sourcePosition === destPosition) {
                return
            }

            console.log('moveTreadle, source: ' + sourcePosition + ', dest: ' + destPosition)

            let tieupSourceColOrig = []
            let treadlingSourceColOrig = []
            for (let r=0; r < tieup.length; r++) {
                tieupSourceColOrig.push(tieup[r][sourcePosition])
            }
            for (let r=0; r < treadling.length; r++) {
                treadlingSourceColOrig.push(treadling[r][sourcePosition])
            }
            let tieupSourceCol = this.deepCopy(tieupSourceColOrig)
            let treadlingSourceCol = this.deepCopy(treadlingSourceColOrig)

            console.log('tieupSourceCol: ' + JSON.stringify(tieupSourceCol))
            console.log('treadlingSourceCol: ' + JSON.stringify(treadlingSourceCol))

            this.removeTreadle(tieup, treadling, sourcePosition)
            this.addTreadle(tieup, treadling, destPosition, tieupSourceCol, treadlingSourceCol)
        },

        rollTieupDown(draft) {
            let originalTieup = new Array(draft.ShaftsCount)
            this.loadNativeOrderTieupArrayFromDraftJSON(originalTieup, draft)

            // console.log('originalTieupArray: ')
            // this.printTieup(originalTieup)

            let newTieup = this.buildEmpty2DArray(draft.ShaftsCount, draft.TreadlesCount)
            this.roll2dArrayDown(originalTieup, newTieup)

            // console.log('newTieupArray: ')
            // this.printTieup(newTieup)

            this.loadDraftJSONFromNativeOrderTieupArray(newTieup, draft)
            return newTieup
        },

        rollTieupUp(draft) {
            let originalTieup = new Array(draft.ShaftsCount)
            this.loadNativeOrderTieupArrayFromDraftJSON(originalTieup, draft)

            // console.log('originalTieupArray: ')
            // this.printTieup(originalTieup)

            let newTieup = this.buildEmpty2DArray(draft.ShaftsCount, draft.TreadlesCount)
            this.roll2dArrayUp(originalTieup, newTieup)
            // console.log('newTieupArray: ')
            // this.printTieup(newTieup)

            this.loadDraftJSONFromNativeOrderTieupArray(newTieup, draft)
            return newTieup
        },

        rollTieupLeft(draft) {
            let originalTieup = new Array(draft.ShaftsCount)
            this.loadNativeOrderTieupArrayFromDraftJSON(originalTieup, draft)

            // console.log('originalTieupArray: ')
            // this.printTieup(originalTieup)

            let newTieup = this.buildEmpty2DArray(draft.ShaftsCount, draft.TreadlesCount)
            this.roll2dArrayLeft(originalTieup, newTieup)

            // console.log('newTieupArray: ')
            // this.printTieup(newTieup)

            this.loadDraftJSONFromNativeOrderTieupArray(newTieup, draft)
            return newTieup
        },

        rollTieupRight(draft) {
            let originalTieup = new Array(draft.ShaftsCount)
            this.loadNativeOrderTieupArrayFromDraftJSON(originalTieup, draft)

            // console.log('originalTieupArray: ')
            // this.printTieup(originalTieup)

            let newTieup = this.buildEmpty2DArray(draft.ShaftsCount, draft.TreadlesCount)
            this.roll2dArrayRight(originalTieup, newTieup)

            // console.log('newTieupArray: ')
            // this.printTieup(newTieup)

            this.loadDraftJSONFromNativeOrderTieupArray(newTieup, draft)
            return newTieup
        },

        roll2dArrayDown(originalTieup, newTieup) {
            let height = originalTieup.length
            let width = originalTieup[0].length
            for (let row = 0; row < height; row++) {
                let sourceRow = row + 1
                if (sourceRow === height) {
                    sourceRow = 0
                }
                for (let col=0; col < width; col++) {
                    let sourceCol = col
                    newTieup[row][col] = originalTieup[sourceRow][sourceCol]
                }
            }
        },

        roll2dArrayUp(originalTieup, newTieup) {
            let height = originalTieup.length
            let width = originalTieup[0].length
            for (let row = 0; row < height; row++) {
                let sourceRow = row - 1
                if (sourceRow < 0) {
                    sourceRow = height - 1
                }
                for (let col=0; col < width; col++) {
                    let sourceCol = col
                    newTieup[row][col] = originalTieup[sourceRow][sourceCol]
                }
            }
        },

        roll2dArrayLeft(originalTieup, newTieup) {
            let height = originalTieup.length
            let width = originalTieup[0].length
            for (let row = 0; row < height; row++) {
                let sourceRow = row
                for (let col=0; col < width; col++) {
                    let sourceCol = col + 1
                    if (sourceCol === width) {
                        sourceCol = 0
                    }
                    newTieup[row][col] = originalTieup[sourceRow][sourceCol]
                }
            }
        },

        roll2dArrayRight(originalTieup, newTieup) {
            let height = originalTieup.length
            let width = originalTieup[0].length
            for (let row = 0; row < height; row++) {
                let sourceRow = row
                for (let col=0; col < width; col++) {
                    let sourceCol = col - 1
                    if (sourceCol < 0) {
                        sourceCol = width - 1
                    }
                    newTieup[row][col] = originalTieup[sourceRow][sourceCol]
                }
            }
        },

        rotateDraftTieup(draft) {
            let originalShaftsCount = draft.ShaftsCount
            let originalTreadlesCount = draft.TreadlesCount

            let originalTieupGrid = new Array(originalTreadlesCount)
            this.loadNativeOrderTieupArrayFromDraftJSON(originalTieupGrid, draft)
            // console.log('existingTieupGrid before rotation:' + JSON.stringify(originalTieupGrid))
            let newTieupGrid = this.rotateTieupArray(originalTieupGrid, originalShaftsCount, originalTreadlesCount)
            // console.log('newTieupGrid after rotation: ' + JSON.stringify(newTieupGrid))

            this.loadDraftJSONFromNativeOrderTieupArray(newTieupGrid, draft)
        },

        turnDraft(draft) {
            let turnedDraft = this.deepCopy(draft)
            this.turnAndInvertDraftTieup(turnedDraft)
            turnedDraft.WarpThreadsCount = draft.WeftThreadsCount
            turnedDraft.WeftThreadsCount = draft.WarpThreadsCount
            turnedDraft.WarpThreads = this.deepCopy(draft.WeftThreads)
            turnedDraft.WeftThreads = this.deepCopy(draft.WarpThreads)
            turnedDraft.Treadling = this.deepCopy(draft.Threading)
            turnedDraft.Threading = this.deepCopy(draft.Treadling)
            turnedDraft.ShaftsCount = draft.TreadlesCount
            turnedDraft.TreadlesCount = draft.ShaftsCount
            turnedDraft.IsRisingShed = draft.IsRisingShed
            return turnedDraft
        },

        turnAndInvertDraftTieup(draft) {
            let originalShaftsCount = draft.ShaftsCount
            let originalTreadlesCount = draft.TreadlesCount

            let originalTieupGrid = new Array(originalShaftsCount)
            this.loadNativeOrderTieupArrayFromDraftJSON(originalTieupGrid, draft)

            // console.log('exisitngTieupGrid before turn: ' + JSON.stringify(originalTieupGrid))
            let turnedTieupArray = this.turnTieupArray(originalTieupGrid, originalShaftsCount, originalTreadlesCount)
            turnedTieupArray = this.invertTieupArray(turnedTieupArray, originalTreadlesCount, originalShaftsCount)
            // console.log('exisitngTieupGrid after turn: ' + JSON.stringify(originalTieupGrid))
            // console.log('newTieupGrid from turn: ' + JSON.stringify(newTieupGrid))

            draft.ShaftsCount = originalTreadlesCount
            draft.TreadlesCount = originalShaftsCount

            this.loadDraftJSONFromNativeOrderTieupArray(turnedTieupArray, draft)
        },

        rotateTieupArray(tieupArray, treadlesCount, shaftsCount) {
            let rotatedTieupArray = new Array()
            for (let i=0; i < shaftsCount; i++) {
                let rowArray = new Array(treadlesCount)
                rotatedTieupArray.push(rowArray)
            }
            for (let shaft=0; shaft < shaftsCount; shaft++) {
                for (let treadle = 0; treadle < treadlesCount; treadle++) {
                    rotatedTieupArray[shaft][treadle] = tieupArray[treadle][shaftsCount-shaft-1]
                }
            }

            return rotatedTieupArray
        },

        turnTieupArray(tieupArray, originalShaftsCount, originalTreadlesCount) {
            let turnedTieupArray = new Array()
            // console.log('turnTieupArray originalShaftsCount: ' + originalShaftsCount + ', originalTreadlesCount: ' + originalTreadlesCount)
            for (let i=0; i < originalTreadlesCount; i++) {
                let rowArray = new Array(originalShaftsCount)
                turnedTieupArray.push(rowArray)
            }
            for (let shaft=0; shaft < originalTreadlesCount; shaft++) {
                for (let treadle = 0; treadle < originalShaftsCount; treadle++) {
                    turnedTieupArray[shaft][treadle] = tieupArray[treadle][shaft]
                }
            }

            return turnedTieupArray
        },

        invertTieupArray(tieupArray, shaftsCount, treadlesCount) {
            let invertedTieupArray = this.deepCopy(tieupArray)
            for (let s=0; s < shaftsCount; s++) {
                for (let t=0; t < treadlesCount; t++) {
                    let currentValue = invertedTieupArray[s][t]
                    invertedTieupArray[s][t] = currentValue ? false : true
                }
            }
            return invertedTieupArray
        },

        compactDraft(draft) {
            let compactedThreadingDraft = this.compactDraftThreading(draft)
            let compactedDraft = this.compactDraftTreadling(compactedThreadingDraft)
            return compactedDraft
        },

        compactDraftThreading(draft) {
            let tieupGridArray = []
            let treadlingGridArray = []
            let threadingGridArray = []
            this.loadNativeOrderTieupArrayFromDraftJSON(tieupGridArray, draft)
            this.loadNativeOrderThreadingArrayFromDraftJSON(threadingGridArray, draft)
            this.loadNativeOrderTreadlingArrayFromDraftJSON(treadlingGridArray, draft)

            // these are sparse arrays like SimpleDraft JSON uses, not grids
            let compactedTieupOutputArray = []
            let compactedThreadingOutputArray = []
            this.compactThreading(threadingGridArray, tieupGridArray, compactedThreadingOutputArray, compactedTieupOutputArray)

            let compactedDraft = {}
            compactedDraft.ShaftsCount = compactedTieupOutputArray.length
            compactedDraft.TreadlesCount = draft.TreadlesCount
            compactedDraft.WarpThreadsCount = draft.WarpThreadsCount
            compactedDraft.WeftThreadsCount = draft.WeftThreadsCount
            this.loadDraftJSONFromNativeOrderTieupArray(compactedTieupOutputArray, compactedDraft)
            this.loadDraftJSONFromNativeOrderThreadingArray(compactedThreadingOutputArray, compactedDraft)
            compactedDraft.Treadling = this.deepCopy(draft.Treadling)
            compactedDraft.WarpThreads = draft.WarpThreads
            compactedDraft.WeftThreads = draft.WeftThreads
            compactedDraft.IsRisingShed = draft.IsRisingShed
            return compactedDraft
        },

        compactDraftTreadling(draft) {
            let tieupGridArray = []
            let treadlingGridArray = []
            let threadingGridArray = []
            this.loadNativeOrderTieupArrayFromDraftJSON(tieupGridArray, draft)
            this.loadNativeOrderThreadingArrayFromDraftJSON(threadingGridArray, draft)
            this.loadNativeOrderTreadlingArrayFromDraftJSON(treadlingGridArray, draft)

            // these are sparse arrays like SimpleDraft JSON uses, not grids
            let compactedTieupOutputArray = []
            let compactedTreadlingOutputArray = []
            this.compactTreadling(treadlingGridArray, tieupGridArray, compactedTreadlingOutputArray, compactedTieupOutputArray)

            let compactedDraft = {}
            compactedDraft.ShaftsCount = draft.ShaftsCount
            compactedDraft.TreadlesCount = compactedTieupOutputArray[0].length
            compactedDraft.WarpThreadsCount = draft.WarpThreadsCount
            compactedDraft.WeftThreadsCount = draft.WeftThreadsCount
            this.loadDraftJSONFromNativeOrderTieupArray(compactedTieupOutputArray, compactedDraft)
            this.loadDraftJSONFromNativeOrderTreadlingArray(compactedTreadlingOutputArray, compactedDraft)
            compactedDraft.Threading = this.deepCopy(draft.Threading)
            compactedDraft.WarpThreads = draft.WarpThreads
            compactedDraft.WeftThreads = draft.WeftThreads
            compactedDraft.IsRisingShed = draft.IsRisingShed
            return compactedDraft
        },

        expandDraftShafts(draft, desiredShafts) {
            // repeat a single warp unit of the draft until warp threads count >= desired shafts
            // expand the draft
            // repeat expanded draft until >= greater of desired shafts or original warp threads count
            // trim repeated expanded draft to greater of desired shafts or original warp threads count

            let originalShaftsCount = draft.ShaftsCount
            let originalWarpThreadsCount = draft.WarpThreadsCount
            let originalWeftThreadsCount = draft.WeftThreadsCount

            let compactionAmounts = this.getCompactionAmounts(draft)
            let minimumPossibleShafts = originalShaftsCount - compactionAmounts.shaftsReduction

            let targetShafts = Math.max(desiredShafts, minimumPossibleShafts)
            if (targetShafts === originalShaftsCount) {
                return draft // desiredShafts is <= minimumPossibleShafts
            }

            // repeat a single warp unit of the draft until warp threads count >= desired shafts
            let repeatsInfo = this.analyzeDraftRepeatsOneThreadMaxPartial(draft, true) //  consider colors for expansion repeats
            let warpUnitThreadsCount = repeatsInfo.warpRepeats.unitRepeatSize
            let singleUnitDraft = this.trimDraftThreads(warpUnitThreadsCount, originalWeftThreadsCount, draft)

            let minimumRepeatsCount = Math.floor(desiredShafts / warpUnitThreadsCount)
            if (desiredShafts % warpUnitThreadsCount > 0) {
                minimumRepeatsCount++
            }
            if (minimumRepeatsCount === 0) { // can't expand to desiredShafts when one unit repeat of the pattern must have more shafts
                return draft
            }

            let repeatedSingleUnitDraft = this.repeatDraft(minimumRepeatsCount, 1, singleUnitDraft)

            // expand the draft
            let straightThreadedDraft = this.straightenWarpThreads(repeatedSingleUnitDraft)
            let straightTieupArray = new Array(straightThreadedDraft.ShaftsCount)
            this.loadNativeOrderTieupArrayFromDraftJSON(straightTieupArray, straightThreadedDraft)

            // create the new tieup array, leaving as straight as possible for the desired shafts
            // while including at least one of each of the shaft rows in the original tieup
            let expandedTieupArray = this.deepCopy(straightTieupArray)

            let initialTieupRepeats = Math.floor(desiredShafts / straightThreadedDraft.ShaftsCount)
            if (desiredShafts % straightThreadedDraft.ShaftsCount > 0) {
                initialTieupRepeats++
            }

            let initialExpandedShafts = initialTieupRepeats * straightThreadedDraft.ShaftsCount

            // if the straightened tieup has fewer shafts than the desired number, duplicate it to stretch out
            let source = 0
            let dest = expandedTieupArray.length

            while (dest < initialExpandedShafts) {
                let rowToCopy = this.deepCopy(expandedTieupArray[source])
                expandedTieupArray.push(rowToCopy)
                dest++
                source++
            }

            // create the new threading array to match the straightened expanded tieup, setting it to a straight threading
            // as we will keep as much of the new draft straight threaded as possible
            let expandedStraightThreadingArray = this.buildEmpty2DArray(initialExpandedShafts, straightThreadedDraft.WarpThreadsCount)
            let shaft = 0
            for (let thread=0; thread < straightThreadedDraft.WarpThreadsCount; thread++) {
                expandedStraightThreadingArray[shaft][thread] = true
                shaft++
                if (shaft === initialExpandedShafts) {
                    shaft = 0
                }
            }

            this.print2dArray(expandedTieupArray)

            let finalTieupArray = this.deepCopy(expandedTieupArray)
            this.reduceTieupToTargetShafts(finalTieupArray, desiredShafts)

            // map the threading shaft assignment tieup rows from the straightened and expanded version to the final version with the desired number of shafts
            let finalThreadingArray = this.buildEmpty2DArray(desiredShafts, repeatedSingleUnitDraft.WarpThreadsCount)

            let nextStartingShaftNumber = 0

            for (let thread=0; thread < repeatedSingleUnitDraft.WarpThreadsCount; thread++) {
                console.log('thread: ' + thread)
                let straightShaftNumber = this.getShaftNumberForThread(expandedStraightThreadingArray, thread)
                let replacementShaftNumber = this.getNextEqualShaftNumber(expandedTieupArray, straightShaftNumber, finalTieupArray, desiredShafts, nextStartingShaftNumber)
                if (replacementShaftNumber > -1) {
                    finalThreadingArray[replacementShaftNumber][thread] = true
                    nextStartingShaftNumber = replacementShaftNumber + 1
                    if (nextStartingShaftNumber > desiredShafts) {
                        nextStartingShaftNumber = 0
                    }
                }
            }

            let finalDraft = this.deepCopy(repeatedSingleUnitDraft)
            finalDraft.ShaftsCount = finalTieupArray.length
            finalDraft.WarpThreadsCount = finalThreadingArray[0].length

            this.loadDraftJSONFromNativeOrderTieupArray(finalTieupArray, finalDraft)
            this.loadDraftJSONFromNativeOrderThreadingArray(finalThreadingArray, finalDraft)

            let outputWarpThreadsCount = Math.max(desiredShafts, originalWarpThreadsCount) // calculate greater of desired shafts or original warp threads count

            // repeat expanded draft until >= greater of desired shafts or original warp threads count
            if (finalDraft.WarpThreadsCount < outputWarpThreadsCount) {
                let finalDraftRepeatsCount = Math.floor(outputWarpThreadsCount / finalDraft.WarpThreadsCount)
                if (outputWarpThreadsCount % finalDraft.WarpThreadsCount > 0) {
                    finalDraftRepeatsCount++
                }
                finalDraft = this.repeatDraft(finalDraftRepeatsCount, 1, finalDraft)
            }

            // trim repeated expanded draft to original warp threads count
            this.trimDraftThreads(outputWarpThreadsCount, originalWeftThreadsCount, finalDraft)

            // this.applyWarpColorsFromOriginalDraft(draft, finalDraft, 0)
            // this.applyWeftColorsFromOriginalDraft(draft, finalDraft, 0)

            return finalDraft
        },

        reduceTieupToTargetShafts(tieupArray, targetShafts) {
            for (let shaft=tieupArray.length-1; shaft > 0; shaft--) {
                // let key = this.getTieupShaftRowKey(tieupArray, shaft)
                // let finder = ''
                // if (key === '1,0,1,1,1,0,1,1,1,0,1,0,1,0,1,1') {
                //     finder = true
                // }
                if (tieupArray.length === targetShafts) {
                    return // finder
                }
                if (this.tieupHasLowerDuplicateShaft(tieupArray, shaft)) {
                    tieupArray.splice(shaft, 1) // take out the matching one that is duplicated below
                }
            }
        },

        tieupHasLowerDuplicateShaft(tieupArray, shaft) {
            console.log('tieupHasLowerDuplicateShaft: ' + shaft)
            for (let row=shaft-1; row >= 0; row--) {
                if (this.equal2dArrayRows(tieupArray, shaft, row)) {
                    return true
                }
            }
            return false
        },

        getNextEqualShaftNumber(expandedTieupArray, expandedShaftNumber, finalTieupArray, desiredShafts, startingNumber) {
            for (let numberTried=0; numberTried < desiredShafts; numberTried++) {
                let finalShaft = (startingNumber + numberTried) % desiredShafts
                if (this.equalMultiple2dArrayRows(expandedTieupArray, finalTieupArray, expandedShaftNumber, finalShaft)) {
                    return finalShaft
                }
            }
            return -1 // shouldn't happen
        },

        getShaftNumberForThread(threadingArray, threadNumber) {
            for (let shaft = 0; shaft < threadingArray.length; shaft++) {
                if (threadingArray[shaft][threadNumber]) {
                    return shaft
                }
            }
            return -1 // should not happen unless there is an empty thread
        },

        getTieupShaftRowKey(tieup, shaft) {
            let key = ''
            let columns = tieup[0].length
            for (let c=0; c < columns; c++) {
                if (key.length > 0) {
                    key += ','
                }
                key += tieup[shaft][c] ? '1' : '0'
            }
            return key
        },

        getWarpThreadCountsPerShaft(threadingArray) {
            let shaftsCount = threadingArray.length
            let warpThreadsCount = threadingArray[0].length
            let results = new Array(shaftsCount)

            for (let shaft=0; shaft < shaftsCount; shaft++) {
                results[shaft] = { 'shaft': shaft+1, 'count': 0 }
            }

            for (let shaft=0; shaft < shaftsCount; shaft++) {
                for (let thread=0; thread < warpThreadsCount; thread++) {
                    if (threadingArray[shaft][thread]) {
                        results[shaft].count++
                    }
                }
            }
            return results
        },

        reassignAndRemoveShaft(threadingArray, tieupArray, shaftNumber, replacementShaftNumber) {
            let warpThreadsCount = threadingArray[0].length
            for (let threadNumber=0; threadNumber < warpThreadsCount; threadNumber++) {
                if (this.getShaftNumberForThread(threadingArray, threadNumber) === shaftNumber) {
                    this.clearRowMajorArrayColumn(threadingArray, threadNumber)
                    threadingArray[replacementShaftNumber][threadNumber] = true
                }
            }
            threadingArray.splice(shaftNumber, 1)
            tieupArray.splice(shaftNumber, 1)
        },

        clearRowMajorArrayColumn(arr, colNum) {
            for (let r=0; r < arr.length; r++) {
                arr[r][colNum] = false
            }
        },

        expandDraftTreadles(draft, targetTreadles) {
            let turnedDraft = this.turnDraft(draft)
            let turnedExpandedDraft = this.expandDraftShafts(turnedDraft, targetTreadles)
            let expandedDraft = this.turnDraft(turnedExpandedDraft)
            return expandedDraft
        },

        squareDraft(sourceDraft) {
            let weftRepeats = 1
            let warpRepeats = 1
            if (sourceDraft.WarpThreadsCount < sourceDraft.WeftThreadsCount) {
                weftRepeats = 2
                warpRepeats = Math.floor((weftRepeats * sourceDraft.WeftThreadsCount) / sourceDraft.WarpThreadsCount)
            }
            else {
                warpRepeats = 2
                weftRepeats = Math.floor((warpRepeats * sourceDraft.WarpThreadsCount) / sourceDraft.WeftThreadsCount)
            }
            return this.repeatDraft(warpRepeats, weftRepeats, sourceDraft)
        },

        straightenWarpThreads(sourceDraft) {
            console.log(JSON.stringify(sourceDraft))

            let compactedSourceDraft = this.compactDraft(sourceDraft)

            let repeatsInfo = this.analyzeDraftRepeatsOneThreadMaxPartial(compactedSourceDraft, false) // don't consider colors here for rethreading
            let warpUnitThreadsCount = repeatsInfo.warpRepeats.unitRepeatSize

            let existingNativeOrderTieupArray = new Array(compactedSourceDraft.ShaftsCount)
            this.loadNativeOrderTieupArrayFromDraftJSON(existingNativeOrderTieupArray, sourceDraft)

            let newNativeOrderTieupArray = []
            for (let c=0; c<warpUnitThreadsCount; c++) {
                let tieupEntryIndex = sourceDraft.Threading[c][0] // get the thread's shaft number
                newNativeOrderTieupArray.push(existingNativeOrderTieupArray[tieupEntryIndex]) // now push the corresponding entry from the old tieup into this position for the straight threading in the new tieup
            }

            console.log('newNativeOrderTieupArray: ' + JSON.stringify(newNativeOrderTieupArray))

            let straightThreadedDraft = this.deepCopy(sourceDraft)
            straightThreadedDraft.ShaftsCount = warpUnitThreadsCount
            this.loadDraftJSONFromNativeOrderTieupArray(newNativeOrderTieupArray, straightThreadedDraft)

            straightThreadedDraft.Threading = []
            let shaftNumber = 0
            for (let c=0; c < sourceDraft.WarpThreadsCount; c++) {
                let threadArray = []
                threadArray.push(shaftNumber)
                shaftNumber++
                if (shaftNumber === warpUnitThreadsCount) {
                    shaftNumber = 0
                }
                straightThreadedDraft.Threading.push(threadArray)
            }
            console.log(JSON.stringify(straightThreadedDraft))
            return this.deepCopy(straightThreadedDraft)
        },

        straightenWeftThreads(sourceDraft) {
            let turnedDraft = this.turnDraft(sourceDraft)
            let straightDraft = this.straightenWarpThreads(turnedDraft)
            let finalDraft = this.turnDraft(straightDraft)
            return finalDraft
        },

        repeatDraft(warpRepeats, weftRepeats, sourceDraft) {
            let tieupArray = this.deepCopyNestedIntArray(sourceDraft.Tieup)
            let threadingArray = []
            let treadlingArray = []
            let warpThreadsArray = []
            let weftThreadsArray = []

            for (let c=0; c < warpRepeats; c++) {
                let threadingCopy = this.deepCopyNestedIntArray(sourceDraft.Threading)
                let warpThreadsCopy = this.deepCopyThreadsArray(sourceDraft.WarpThreads)
                threadingArray = threadingArray.concat(threadingCopy)
                warpThreadsArray = warpThreadsArray.concat(warpThreadsCopy)
            }

            for (let c=0; c < weftRepeats; c++) {
                let treadlingCopy = this.deepCopyNestedIntArray(sourceDraft.Treadling)
                let weftThreadsCopy = this.deepCopyThreadsArray(sourceDraft.WeftThreads)
                treadlingArray = treadlingArray.concat(treadlingCopy)
                weftThreadsArray = weftThreadsArray.concat(weftThreadsCopy)
            }

            let repeatedDraft = {}
            repeatedDraft.Tieup = tieupArray
            repeatedDraft.ShaftsCount = sourceDraft.ShaftsCount
            repeatedDraft.TreadlesCount = sourceDraft.TreadlesCount
            repeatedDraft.WarpThreadsCount = sourceDraft.WarpThreadsCount * warpRepeats
            repeatedDraft.WeftThreadsCount = sourceDraft.WeftThreadsCount * weftRepeats

            repeatedDraft.Threading = threadingArray
            repeatedDraft.Tieup = tieupArray
            repeatedDraft.Treadling = treadlingArray
            repeatedDraft.WarpThreads = warpThreadsArray
            repeatedDraft.WeftThreads = weftThreadsArray

            return repeatedDraft
        },

        trimDraftThreads(warpThreadsKeepCount, weftThreadsKeepCount, sourceDraft) {
            let tieupArray = this.deepCopyNestedIntArray(sourceDraft.Tieup)
            let threadingArray = []
            let treadlingArray = []
            let warpThreadsArray = []
            let weftThreadsArray = []

            for (let c=0; c < warpThreadsKeepCount; c++) {
                threadingArray.push(this.deepCopy(sourceDraft.Threading[c]))
                warpThreadsArray.push(this.deepCopy(sourceDraft.WarpThreads[c]))
            }

            for (let c=0; c < weftThreadsKeepCount; c++) {
                treadlingArray.push(this.deepCopy(sourceDraft.Treadling[c]))
                weftThreadsArray.push(this.deepCopy(sourceDraft.WeftThreads[c]))
            }

            let trimmedDraft = {}
            trimmedDraft.Tieup = tieupArray
            trimmedDraft.ShaftsCount = sourceDraft.ShaftsCount
            trimmedDraft.TreadlesCount = sourceDraft.TreadlesCount
            trimmedDraft.WarpThreadsCount = warpThreadsKeepCount
            trimmedDraft.WeftThreadsCount = weftThreadsKeepCount

            trimmedDraft.Threading = threadingArray
            trimmedDraft.Treadling = treadlingArray
            trimmedDraft.WarpThreads = warpThreadsArray
            trimmedDraft.WeftThreads = weftThreadsArray

            return trimmedDraft
        },

        getNativeOrderDrawdownArray(draft) {
            let threadingArray = new Array(draft.WarpThreadsCount)
            this.loadNativeOrderThreadingArrayFromDraftJSON(threadingArray, draft)

            let treadlingArray = new Array(draft.WeftThreadsCount)
            this.loadNativeOrderTreadlingArrayFromDraftJSON(treadlingArray, draft)

            let tieupArray = new Array(draft.TreadlesCount)
            this.loadNativeOrderTieupArrayFromDraftJSON(tieupArray, draft)

            let drawdownArray = []
            for (let t=0; t < draft.WarpThreadsCount; t++) {
                drawdownArray.push(new Array(draft.WeftThreadsCount))
            }
            this.loadDrawdown(draft.ShaftsCount, draft.TreadlesCount, draft.WarpThreadsCount, draft.WeftThreadsCount, null, null, drawdownArray, treadlingArray, threadingArray, tieupArray)
            return drawdownArray
        },

        draftHasStraightThreading(draft) {
            for (let c=0; c < draft.WarpThreadsCount; c++) {
                let shaftNumber = draft.Threading[c][0]
                if (shaftNumber !== c % draft.ShaftsCount) {
                    return false
                }
            }
            return true
        },

        draftHasStraightTreadling(draft) {
            let turnedDraft = this.turnDraft(draft)
            return this.draftHasStraightThreading(turnedDraft)
        },

        draftHasPointThreading(draft) {
            let repeatsInfo = this.analyzeDraftRepeatsOneThreadMaxPartial(draft, false) // don't consider colors here for rethreading
            let warpUnitThreadsCount = repeatsInfo.warpRepeats.unitRepeatSize
            let weftUnitThreadsCount = repeatsInfo.weftRepeats.unitRepeatSize
            let singleRepeatDraft = this.trimDraftThreads(warpUnitThreadsCount, weftUnitThreadsCount, draft)

            if (singleRepeatDraft.WarpThreadsCount < (singleRepeatDraft.ShaftsCount * 2)-2) {
                return false // not enough threads to be point threaded
            }

            let expectedShaftNumber = -1
            let direction = 1
            for (let c=0; c < singleRepeatDraft.WarpThreadsCount; c++) {
                expectedShaftNumber += direction
                if (expectedShaftNumber !== singleRepeatDraft.Threading[c][0]) {
                    return false
                }
                if (expectedShaftNumber+1 === singleRepeatDraft.ShaftsCount) {
                    direction *= -1
                }
            }
            return true
        },

        draftHasPointTreadling(draft) {
            let turnedDraft = this.turnDraft(draft)
            return this.draftHasPointThreading(turnedDraft)
        },

        applyWarpColorsFromOriginalDraft(originalDraft, newDraft, pointThreadingStartOffset) {
            let warpThreadsArray = new Array(originalDraft.WarpThreadsCount)
            this.loadNativeOrderWarpThreadsArrayFromDraftJSON(warpThreadsArray, originalDraft)
            let newWarpThreadsArray = []

            let t = pointThreadingStartOffset
            for (let thread=0; thread < newDraft.WarpThreadsCount; thread++) {
                newWarpThreadsArray.push(this.deepCopy(warpThreadsArray[t]))
                t++
                if (t === warpThreadsArray.length) {
                    t = 0
                }
            }
            this.loadDraftJSONFromNativeOrderWarpThreadsArray(newWarpThreadsArray, newDraft)
        },

        applyWeftColorsFromOriginalDraft(originalDraft, newDraft, pointTreadlingStartOffset) {
            let weftThreadsArray = new Array(originalDraft.WeftThreadsCount)
            this.loadNativeOrderWeftThreadsArrayFromDraftJSON(weftThreadsArray, originalDraft)
            let newWeftThreadsArray = []

            let t = pointTreadlingStartOffset
            for (let thread=0; thread < newDraft.WeftThreadsCount; thread++) {
                newWeftThreadsArray.push(this.deepCopy(weftThreadsArray[t]))
                t++
                if (t === weftThreadsArray.length) {
                    t = 0
                }
            }
            this.loadDraftJSONFromNativeOrderWeftThreadsArray(newWeftThreadsArray, newDraft)
        },

        printTieup(t) {
            let tieupStr = '\n'
            for (let row = 0; row < t.length; row++) {
                for (let col=0; col < t[0].length; col++) {
                    if (t[row][col]) {
                        tieupStr += '1 '
                    }
                    else {
                        tieupStr += '0 '
                    }
                }
                tieupStr += '\n'
            }
            this.timelog(tieupStr)
        }

    }
}
